import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Title from '../../../components/Title';
import { routePaths } from '../../../router/paths';
import { currentLang } from '../../../../../utils/lang';
import { getPaths } from '../../../utils/element';
import { filterStores } from '../../../store/slices/storesSlice';
import { StoreService } from '../../../types/store';
const LendIqos = () => {
    const { t } = useTranslation();
    const currentLocale = currentLang();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(filterStores({ services: [StoreService.Lending] }));
        return () => {
            dispatch(filterStores({}));
        };
    }, []);
    return (_jsxs("div", { children: [_jsx(Title, { title: t('store_locator.lend-iqos.title') }), _jsxs("div", { className: "list-group list-group-padless mb-4", children: [_jsx("a", { target: "_blank", rel: "noreferrer", href: getPaths().app_tryout_registration, className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: t('store_locator.lend-iqos.try_it_form') }), _jsx(Link, { to: routePaths.IqosStores[currentLocale], className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: t('store_locator.lend-iqos.show_brand_stores') })] })] }));
};
export default LendIqos;
